import React from "react";
import "./EpicsIEEEPage.css";

function EpicsIEEEPage() {
  return (
    <div className="epics-page">

      {/* ================= HERO SECTION ================= */}
      <section
        className="epics-hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/photos/epics.jpg)`
        }}
      >
        <div className="hero-overlay">
          <h1>EPICS in IEEE – REACH Initiative</h1>
          <p>
            Engineering Projects in Community Service (EPICS) – Transforming
            Rural Healthcare through AI Innovation
          </p>
        </div>
      </section>




      {/* ================= ABOUT EPICS ================= */}
      <section className="epics-section">
        <div className="epics-container">
          <h2>About EPICS in IEEE</h2>
          <p>
            EPICS in IEEE (Engineering Projects in Community Service) is a
            global initiative that empowers students and professionals to
            apply engineering and technology to solve real-world community
            challenges.
          </p>

          <p>
            The REACH – Rural Educational Advancement for Community Health –
            Web App Initiative aligns with EPICS by integrating Artificial
            Intelligence, Nutrition Modeling, and Health Awareness systems to
            support underserved rural communities in Assam, India.
          </p>
        </div>
      </section>

     {/* ================= TARGET REGION ================= */}
<section className="epics-section light-bg">
  <div className="epics-container">

    <h2>Target Region – Barjalenga Development Area, Cachar District, Assam</h2>

    {/* ================= LOCATION MAP ================= */}
    <div className="region-map-wrapper">
      <img
        src="/photos/reach6.png"
        alt="Barjalenga Location Map"
        className="region-map-image"
      />
    </div>

    {/* ================= OVERVIEW TEXT ================= */}
    <div className="region-overview">
      <p>
        The Barjalenga Development Area lies under the Silchar Subdivision of
        Cachar District in the state of Assam, India. Located approximately
        27 kilometres from Silchar town, the region represents a cluster of
        rural settlements with diverse socio-economic and demographic
        characteristics.
      </p>

      <p>
        The block comprises multiple villages including Bor Jalenga Grant,
        Barjalenga Pt I, Pt V, Pt VIII and Pt XI. These villages collectively
        represent a population exceeding 7,900 residents, with varying literacy
        levels, workforce participation patterns and vulnerability to seasonal
        climatic risks.
      </p>
    </div>

    <div className="grid-2">

      {/* ================= LEFT: DEMOGRAPHICS ================= */}
      <div className="region-content">

        <h4>Bor Jalenga Grant Village</h4>
        <p>
          A primary settlement with <strong>2,784 residents</strong> across 661
          households. The literacy rate stands at 71.17%, with a Scheduled Caste
          population of 17.31%.
        </p>

        <h4>Barjalenga Pt I</h4>
        <p>
          Population of <strong>1,357 residents</strong> with literacy nearing
          83%. Male literacy is significantly high at 89.11% while female literacy
          stands at 76.46%.
        </p>

        <h4>Bor Jalenga Pt V</h4>
        <p>
          Home to <strong>1,262 inhabitants</strong> with a literacy rate of
          78.47%. A strong proportion of residents are engaged in main workforce
          activities including agriculture and tea garden labour.
        </p>

        <h4>Bor Jalenga Pt VIII</h4>
        <p>
          With <strong>2,203 residents</strong>, this village records an
          exceptional literacy rate of 92.75%, reflecting strong educational
          engagement.
        </p>

        <h4>Bor Jalenga Pt XI</h4>
        <p>
          A smaller settlement of approximately <strong>474 residents</strong>,
          dependent largely on agricultural and marginal economic activities.
        </p>

        <h4>Regional Challenges</h4>
        <ul>
          <li>Seasonal flooding and waterlogging during monsoon</li>
          <li>Limited healthcare accessibility in peak rainfall months</li>
          <li>Income instability linked to tea garden and daily wage labour</li>
          <li>Child undernutrition and maternal anaemia</li>
          <li>Infrastructure and connectivity constraints</li>
        </ul>

      </div>

      {/* ================= RIGHT: OUTREACH PHOTO GRID ================= */}
      <div className="region-photo-grid">

        <img src="/photos/reach1.jpeg" alt="EPICS Community Session 1" />
        <img src="/photos/reach2.jpeg" alt="EPICS Community Session 2" />
        <img src="/photos/reach3.jpeg" alt="EPICS Outreach Workshop 1" />
        <img src="/photos/reach4.jpeg" alt="EPICS Outreach Workshop 2" />
        <img src="/photos/reach5.jpeg" alt="EPICS Student Engagement Session" />

      </div>

    </div>

    {/* ================= SUMMARY STRIP ================= */}
    <div className="region-highlight-strip">

      <div className="highlight-card">
        <h3>7,980+</h3>
        <p>Total Regional Population</p>
      </div>

      <div className="highlight-card">
        <h3>27 km</h3>
        <p>Distance from Silchar</p>
      </div>

      <div className="highlight-card">
        <h3>92.75%</h3>
        <p>Highest Village Literacy</p>
      </div>

      <div className="highlight-card">
        <h3>Monsoon Flood Risk</h3>
        <p>Seasonal Climate Vulnerability</p>
      </div>

    </div>

  </div>
</section>



      {/* ================= PROJECT IMPACT ================= */}
      <section className="epics-section">
        <div className="epics-container">
          <h2>REACH – Community Impact</h2>

          <div className="impact-grid">
            <div className="impact-card">
              <h3>AI Health Assistant</h3>
              <p>
                Provides contextual medical awareness and guidance in English
                and Bengali.
              </p>
            </div>

            <div className="impact-card">
              <h3>Personalized Nutrition Engine</h3>
              <p>
                AI-driven meal planning based on BMI, lifestyle, and health
                conditions.
              </p>
            </div>

            <div className="impact-card">
              <h3>Multilingual Accessibility</h3>
              <p>
                Designed for rural usability with translation and voice
                interaction.
              </p>
            </div>

            <div className="impact-card">
              <h3>Energy Efficient AI Deployment</h3>
              <p>
                Smart GPU wake-up logic ensures sustainable cloud computing
                usage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= TEAM SECTION ================= */}
      <section className="epics-section light-bg">
  <div className="epics-container">
    <h2>Project Leadership</h2>

    <div className="team-grid">
      <div className="team-card">
        Faculty Advisor – Dr. Mousum Handique
      </div>

      <div className="team-card">
        Technical Lead – Dr. Arnab Paul
      </div>

      <div className="team-card">
        Community Liaison – Dr. Lalso S Thangjom
      </div>

      <div className="team-card">
        Project Volunteers – REACH Team
      </div>

      <div className="team-card">
        Kamalesh Debnath
      </div>

      <div className="team-card">
        Shrinjoy Das
      </div>

      <div className="team-card">
        Avantika Langthasa
      </div>
    </div>

  </div>
</section>

    </div>
  );
}

export default EpicsIEEEPage;
